const OPTS = ["internal", "investor", "creator"];

// Per-record audience approval. 'internal' is always included and non-removable so
// internal staff never lose visibility; admins/editors opt a record into investor/creator.
export function AudienceSelector({ value, onChange, label = "Approved audiences" }) {
  const auds = value && value.length ? value : ["internal"];
  const has = (a) => auds.includes(a);
  const toggle = (a) => {
    if (a === "internal") return;
    const next = has(a) ? auds.filter((x) => x !== a) : [...auds, a];
    onChange(next.includes("internal") ? next : ["internal", ...next]);
  };
  return (
    <div>
      {label && <div className="cm-label mb-1">{label}</div>}
      <div className="flex flex-wrap gap-2">
        {OPTS.map((a) => (
          <button
            type="button"
            key={a}
            data-testid={`audience-${a}`}
            onClick={() => toggle(a)}
            disabled={a === "internal"}
            className={`rounded-sm border px-3 py-1 text-xs transition-colors ${
              has(a)
                ? "border-[#F59E0B] bg-[rgba(245,158,11,0.12)] text-[#F59E0B]"
                : "border-[#2C2C2A] bg-[#1A1A18] text-[#A1A19D] hover:text-[#F9F9F8]"
            } ${a === "internal" ? "cursor-default opacity-90" : ""}`}
          >
            {a}{a === "internal" ? " · default" : ""}
          </button>
        ))}
      </div>
      <p className="mt-1 text-xs text-[#6b6b66]">Internal is always included. Investor/Creator see this record only when explicitly approved here.</p>
    </div>
  );
}
